import React, { useState } from 'react';
import HubspotForm from 'react-hubspot-form';

import { paths } from '@src/constants/pathsEnum';

import { privatePolicyInfo } from '@commons/append-tooltip/payload';
import { appendTooltipToAsterisk } from '@commons/append-tooltip/appendTooltip';
import { NewStandardSection } from '@commons/index';
import { LoadingSpinner } from '@commons/loading-spinner/LoadingSpinner';
import { Button } from '@commons/button/Button';

import infoIcon from '@images/newsletter/info-icon.svg';
import envelope from '@images/newsletter/envelope.svg';

import * as styles from './newsletter-form.module.scss';

const N = () => (
  <svg width="25" height="31" viewBox="0 0 25 31" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      opacity="0.4"
      d="M24.7662 0V30.3949H18.4963L6.26993 10.0203V30.3949H0V0H6.26993L18.5172 20.3955V0H24.7662Z"
      fill="white"
    />
  </svg>
);

const E = () => (
  <svg width="20" height="32" viewBox="0 0 20 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      opacity="0.4"
      d="M19.888 26.22V31.1652H4.11195V26.22H19.888ZM6.10686 0.39502V31.1652H0V0.39502H6.10686ZM17.832 12.9271V17.7455H4.11195V12.9271H17.832ZM19.8677 0.39502V5.36135H4.11195V0.39502H19.8677Z"
      fill="white"
    />
  </svg>
);

const D = () => (
  <svg width="24" height="32" viewBox="0 0 24 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      opacity="0.4"
      d="M9.4859 31.3302H2.75876L2.8012 26.385H9.4859C11.1553 26.385 12.563 26.0116 13.7089 25.2649C14.8549 24.5041 15.7179 23.3982 16.2979 21.947C16.8921 20.4958 17.1892 18.7418 17.1892 16.6848V15.1843C17.1892 13.6064 17.0194 12.2186 16.6799 11.0211C16.3545 9.8235 15.8664 8.81615 15.2156 7.99899C14.5649 7.18184 13.7655 6.56897 12.8176 6.16039C11.8698 5.73773 10.7804 5.52639 9.54956 5.52639H2.63143V0.560059H9.54956C11.6151 0.560059 13.5038 0.912281 15.2156 1.61673C16.9416 2.30708 18.4342 3.30035 19.6933 4.59653C20.9524 5.8927 21.9216 7.44248 22.6006 9.24586C23.2939 11.0351 23.6405 13.0287 23.6405 15.2266V16.6848C23.6405 18.8686 23.2939 20.8622 22.6006 22.6655C21.9216 24.4689 20.9524 26.0187 19.6933 27.3149C18.4483 28.597 16.9558 29.5902 15.2156 30.2947C13.4896 30.985 11.5797 31.3302 9.4859 31.3302ZM6.36637 0.560059V31.3302H0V0.560059H6.36637Z"
      fill="white"
    />
  </svg>
);

const S = () => (
  <svg width="24" height="32" viewBox="0 0 24 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      opacity="0.4"
      d="M17.3025 23.127C17.3025 22.5857 17.218 22.0999 17.049 21.6697C16.8941 21.2255 16.5983 20.823 16.1617 20.4622C15.7251 20.0874 15.1124 19.7196 14.3237 19.3587C13.535 18.9979 12.5139 18.6231 11.2604 18.2345C9.86604 17.7904 8.54212 17.2907 7.28862 16.7355C6.0492 16.1804 4.95063 15.535 3.99289 14.7994C3.04925 14.0499 2.30278 13.1824 1.75349 12.197C1.21829 11.2115 0.950689 10.0665 0.950689 8.76182C0.950689 7.49879 1.23237 6.35374 1.79575 5.32666C2.35912 4.28571 3.14784 3.39743 4.16191 2.66182C5.17597 1.91233 6.37314 1.33633 7.7534 0.933832C9.14774 0.531329 10.6759 0.330078 12.3378 0.330078C14.6054 0.330078 16.5842 0.732581 18.2744 1.53759C19.9645 2.34259 21.2743 3.446 22.2039 4.84782C23.1475 6.24964 23.6193 7.85272 23.6193 9.65704H17.3237C17.3237 8.76876 17.1335 7.99151 16.7533 7.3253C16.3871 6.64521 15.8237 6.11085 15.0631 5.72223C14.3167 5.3336 13.373 5.13929 12.2322 5.13929C11.1336 5.13929 10.2181 5.30584 9.48577 5.63895C8.75338 5.95818 8.2041 6.39538 7.8379 6.95055C7.47171 7.49185 7.28862 8.10255 7.28862 8.78264C7.28862 9.29617 7.41538 9.76113 7.66889 10.1775C7.93649 10.5939 8.33085 10.9825 8.85197 11.3434C9.37309 11.7043 10.0139 12.0443 10.7745 12.3635C11.535 12.6827 12.4153 12.995 13.4153 13.3004C15.0913 13.8 16.5631 14.3622 17.8307 14.9867C19.1124 15.6113 20.1828 16.3122 21.0419 17.0895C21.9011 17.8667 22.5489 18.748 22.9856 19.7335C23.4222 20.7189 23.6405 21.8362 23.6405 23.0854C23.6405 24.4039 23.3799 25.5837 22.8588 26.6246C22.3377 27.6656 21.5842 28.5469 20.5983 29.2686C19.6124 29.9904 18.4363 30.5386 17.0702 30.9133C15.704 31.2881 14.1758 31.4755 12.4857 31.4755C10.9646 31.4755 9.46464 31.2811 7.98579 30.8925C6.50694 30.49 5.16189 29.8863 3.95064 29.0813C2.75348 28.2763 1.79575 27.2492 1.07745 26C0.359149 24.7509 0 23.2727 0 21.5656H6.35905C6.35905 22.5094 6.50694 23.3074 6.80271 23.9598C7.09848 24.6121 7.51397 25.1395 8.04917 25.542C8.59846 25.9445 9.24633 26.236 9.9928 26.4164C10.7534 26.5968 11.5843 26.6871 12.4857 26.6871C13.5843 26.6871 14.4857 26.5344 15.1899 26.229C15.9082 25.9237 16.4364 25.5004 16.7744 24.9591C17.1265 24.4178 17.3025 23.8071 17.3025 23.127Z"
      fill="white"
    />
  </svg>
);

export function NewsletterForm() {
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const policyInfo = privatePolicyInfo.type2;

  return (
    <>
      <div className={styles.backgroundGlow}></div>
      <NewStandardSection>
        <div className={styles.outerWrapper}>
          <div className={styles.outerBorder}></div>
          <div className={styles.innerWrapper}>
            <div className={styles.description}>
              <p className={styles.descriptionParagraph}>
                Gain exclusive access to <span className={styles.bold}>expert insider knowledge</span> about network,
                software and cloud-related topics.
              </p>
              <div className={styles.needsDescription}>
                <p>You will get a knowledge-packet articles focused on NEEDS:</p>
                <ul>
                  <li>
                    <N />
                    <div className={styles.elaboration}>Networks virtualization, automation, design and testing</div>
                  </li>
                  <li>
                    <E />
                    <div className={styles.elaboration}>Equipment: embedded systems and low-level programming</div>
                  </li>
                  <li>
                    <E />
                    <div className={styles.elaboration}>
                      Environment: infrastructure and cloud monitoring or observability
                    </div>
                  </li>
                  <li>
                    <D />
                    <div className={styles.elaboration}>Data engineering and data science</div>
                  </li>
                  <li>
                    <S />
                    <div className={styles.elaboration}>Security for networks and applications</div>
                  </li>
                </ul>
              </div>
              <p className={styles.noSpam}>
                One issue per month. <span className={styles.bold}>No spam!</span>
              </p>
            </div>
            <div className={styles.form}>
              <div id="newsletterFormInBanner" className={styles.formContainer}>
                {isFormSubmitted ? (
                  NewsletterThankYou
                ) : (
                  <NewsLetterHubspotForm setFormSubmitted={setIsFormSubmitted} policyInfo={policyInfo} />
                )}
              </div>
            </div>
          </div>
        </div>
      </NewStandardSection>
    </>
  );
}

const NewsLetterHubspotForm = ({ setFormSubmitted, policyInfo }) => (
  <>
    <h2 className={styles.hubspotTitle}>
      Sign up to our network<span className={styles.white}>-focused newsletter</span>
    </h2>
    <HubspotForm
      portalId="5206705"
      formId="c923975c-c93f-457d-8c28-402d4a54aad5"
      loading={<LoadingSpinner />}
      onReady={() => appendTooltipToAsterisk('#newsletterFormInBanner', policyInfo, infoIcon)}
      onSubmit={() => undefined}
      onFormSubmitted={() => setFormSubmitted(true)}
    />
  </>
);

const NewsletterThankYou = (
  <div className={styles.thankYouContainer}>
    <img className={styles.envelope} src={envelope} alt="envelope" />
    <p className={styles.thankYouMessage}>
      We are thrilled to have you! <br />
      We have sent you a welcome message with additional content.
    </p>
    <p className={styles.exploreBlog}>You can also explore our blog.</p>
    <Button href={paths.BLOG} className={styles.exploreBlogButton} label="Explore blog" />
  </div>
);
